module.exports = __webpack_public_path__ + "img/tank-base-4.36f81ff2.png";